<template>
  <header class="header" ref="headerComponent">
    <a class="header__logo" :href="homepagePath" target="_blank">
      <img src="../assets/icons/logo.svg" />
    </a>
    <langauge v-if="showLanguage" />
    <div v-else>
      <a
        :href="labels.results.cta.path"
        :download="labels.results.cta.path"
        class="header__cta"
        target="_blank"
      >{{ labels.header.cta }}</a>
    </div>
    <scroll-marker :top="headerHeight" />
  </header>
</template>

<script>
import Langauge from "./Language.vue";
import ScrollMarker from "./ScrollMarker.vue";
import { mapGetters } from "vuex";
import { vuexGetters } from "../store";

export default {
  name: "Header",
  components: {
    Langauge,
    ScrollMarker
  },
  data() {
    return {
      headerHeight: 65
    };
  },
  mounted() {
    this.updateHeaderHeight();
    setInterval(this.updateHeaderHeight, 500);
  },
  computed: {
    ...mapGetters({ labels: vuexGetters.I18N }),
    ...mapGetters({
      langCode: vuexGetters.LANG_CODE,
      showLanguage: vuexGetters.SHOW_LANGUAGE_MENU
    }),
    homepagePath() {
      return this.langCode
        ? `https://www.proximus.be/${this.langCode}/self-employed-and-small-companies`
        : `https://www.proximus.be`;
    }
  },
  methods: {
    updateHeaderHeight() {
      this.headerHeight = this.$refs.headerComponent.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  z-index: 50;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;

  &__cta {
    color: $eminence;
    text-decoration: none;
  }
}
.header__logo {
  display: inline-block;
}
</style>